module.exports = __webpack_public_path__ + "images/appstore-btn.a667fca1561d44fabc9e989b6c3ce976.png";